import { PoliticaDura } from '../_models/politica-duras';
import { AppSettings } from '../../proyect.conf';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PoliticasDuraService {

  private rutServicio = AppSettings.rutServiciosAUTOGES + '/api/politicasDuras';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PoliticaDura[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PoliticaDura[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PoliticaDura ) );
  }

  obtenerPorCodigo( codigoPolitica: string) {
    return this.httClient.get(this.rutServicio + '/politicaCodigo/' + codigoPolitica + '/enabled').pipe( map(res => res as PoliticaDura[]) );
  }

  crear( regCrear: PoliticaDura ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PoliticaDura ) );
  }

  actualizar( regActualizar: PoliticaDura ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: PoliticaDura[] ) {
    regActualizar.map( ( s: PoliticaDura ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }
}
